// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Js_exn = require("rescript/lib/js/js_exn.js");
var Core__JSON = require("@rescript/core/src/Core__JSON.res.js");
var Caml_option = require("rescript/lib/js/caml_option.js");

function okResp(res) {
  return {
          isOk: true,
          res: res,
          err: undefined
        };
}

function errResp(msg) {
  return {
          isOk: false,
          res: undefined,
          err: msg
        };
}

function apiInputToObjExn(apiInput, msg) {
  if (apiInput == null) {
    return Js_exn.raiseError(msg);
  } else {
    return apiInput;
  }
}

var apiCallCnt = {
  contents: 0
};

var logApiCallsToConsole = {
  contents: false
};

function makeApiFunc(name, func) {
  return function (params) {
    apiCallCnt.contents = apiCallCnt.contents + 1 | 0;
    var apiCallId = apiCallCnt.contents;
    if (logApiCallsToConsole.contents) {
      console.log("[" + String(apiCallId) + "] <<< " + name, params);
    }
    return func(params).then(function (res) {
                var resp;
                resp = res.TAG === "Ok" ? okResp(res._0) : errResp(res._0);
                if (logApiCallsToConsole.contents) {
                  console.log("[" + String(apiCallId) + "] >>> ", resp);
                }
                return resp;
              });
  };
}

function makeApiFuncFromRef(ref) {
  return function (params) {
    var func = ref.contents;
    if (func !== undefined) {
      return func(params);
    } else {
      return Promise.resolve({
                  isOk: false,
                  res: undefined,
                  err: "The API function is not defined."
                });
    }
  };
}

function makeEmptySingleEditorApi(msg) {
  return {
          getState: (function (param) {
              return Promise.resolve(errResp(msg));
            }),
          proveBottomUp: (function (param) {
              return Promise.resolve(errResp(msg));
            }),
          unifyAll: (function (param) {
              return Promise.resolve(errResp(msg));
            }),
          addSteps: (function (param) {
              return Promise.resolve(errResp(msg));
            }),
          updateSteps: (function (param) {
              return Promise.resolve(errResp(msg));
            }),
          renameSteps: (function (param) {
              return Promise.resolve(errResp(msg));
            }),
          deleteSteps: (function (param) {
              return Promise.resolve(errResp(msg));
            }),
          markStepsChecked: (function (param) {
              return Promise.resolve(errResp(msg));
            }),
          setDisjoints: (function (param) {
              return Promise.resolve(errResp(msg));
            }),
          setDescription: (function (param) {
              return Promise.resolve(errResp(msg));
            }),
          resetEditorContent: (function (param) {
              return Promise.resolve(errResp(msg));
            }),
          getTokenType: (function (param) {
              return Promise.resolve(errResp(msg));
            }),
          substitute: (function (param) {
              return Promise.resolve(errResp(msg));
            }),
          mergeDuplicatedSteps: (function (param) {
              return Promise.resolve(errResp(msg));
            }),
          setContentIsHidden: (function (param) {
              return Promise.resolve(errResp(msg));
            }),
          buildSyntaxTrees: (function (param) {
              return Promise.resolve(errResp(msg));
            }),
          findAsrtsByUnif: (function (param) {
              return Promise.resolve(errResp(msg));
            }),
          addAsrtByLabel: (function (param) {
              return Promise.resolve(errResp(msg));
            })
        };
}

var setLogApiCallsToConsoleRef = {
  contents: undefined
};

var showInfoMsgRef = {
  contents: undefined
};

var showErrMsgRef = {
  contents: undefined
};

var multilineTextInputRef = {
  contents: undefined
};

var editorRef = {
  contents: undefined
};

var macroRef = {
  contents: undefined
};

var settingsRef = {
  contents: undefined
};

function makeSingleMacroApi(methodGetter) {
  return function (apiInput) {
    var macroApi = macroRef.contents;
    if (macroApi !== undefined) {
      return methodGetter(Caml_option.valFromOption(macroApi))(apiInput);
    } else {
      return Promise.resolve({
                  isOk: false,
                  res: undefined,
                  err: "The macro API function is not defined."
                });
    }
  };
}

function makeSingleSettingsApi(methodGetter) {
  return function (apiInput) {
    var settingsApi = settingsRef.contents;
    if (settingsApi !== undefined) {
      return methodGetter(Caml_option.valFromOption(settingsApi))(apiInput);
    } else {
      return Promise.resolve({
                  isOk: false,
                  res: undefined,
                  err: "The settings API function is not defined."
                });
    }
  };
}

function makeMacroApi() {
  return {
          registerMacroModule: makeSingleMacroApi(function (a) {
                return a.registerMacroModule;
              }),
          unregisterMacroModule: makeSingleMacroApi(function (a) {
                return a.unregisterMacroModule;
              }),
          listRegisteredMacroModules: makeSingleMacroApi(function (a) {
                return a.listRegisteredMacroModules;
              }),
          listRegisteredMacrosInModule: makeSingleMacroApi(function (a) {
                return a.listRegisteredMacrosInModule;
              }),
          runMacro: makeSingleMacroApi(function (a) {
                return a.runMacro;
              })
        };
}

function makeSettingsApi() {
  return {
          setMarkFirstProvableStepAsGoal: makeSingleSettingsApi(function (a) {
                return a.setMarkFirstProvableStepAsGoal;
              }),
          getMarkFirstProvableStepAsGoal: makeSingleSettingsApi(function (a) {
                return a.getMarkFirstProvableStepAsGoal;
              })
        };
}

var api = {
  setLogApiCallsToConsole: makeApiFuncFromRef(setLogApiCallsToConsoleRef),
  showInfoMsg: makeApiFuncFromRef(showInfoMsgRef),
  showErrMsg: makeApiFuncFromRef(showErrMsgRef),
  multilineTextInput: makeApiFuncFromRef(multilineTextInputRef),
  editor: (function (editorId) {
      var func = editorRef.contents;
      if (func !== undefined) {
        return func(editorId);
      } else {
        return makeEmptySingleEditorApi("The editor API function is not defined.");
      }
    }),
  macro: makeMacroApi(),
  settings: makeSettingsApi()
};

function setLogApiCallsToConsole(params) {
  var bool = Core__JSON.Decode.bool(params);
  if (bool !== undefined) {
    logApiCallsToConsole.contents = bool;
    return Promise.resolve({
                TAG: "Ok",
                _0: undefined
              });
  } else {
    return Promise.resolve({
                TAG: "Error",
                _0: "The parameter of setLogApiCallsToConsole() must be a boolean."
              });
  }
}

setLogApiCallsToConsoleRef.contents = makeApiFunc("setLogApiCallsToConsole", setLogApiCallsToConsole);

function setUiApi(showInfoMsg, showErrMsg, multilineTextInput) {
  showInfoMsgRef.contents = showInfoMsg;
  showErrMsgRef.contents = showErrMsg;
  multilineTextInputRef.contents = multilineTextInput;
}

function setEditorApi(editorApi) {
  editorRef.contents = editorApi;
}

function setMacroApi(macroApi) {
  macroRef.contents = Caml_option.some(macroApi);
}

function setSettingsApi(settingsApi) {
  settingsRef.contents = Caml_option.some(settingsApi);
}

function apiInputToJson(prim) {
  return prim;
}

function apiInputToNullableObj(prim) {
  return prim;
}

exports.apiInputToJson = apiInputToJson;
exports.apiInputToNullableObj = apiInputToNullableObj;
exports.apiInputToObjExn = apiInputToObjExn;
exports.makeApiFunc = makeApiFunc;
exports.api = api;
exports.setUiApi = setUiApi;
exports.setEditorApi = setEditorApi;
exports.setMacroApi = setMacroApi;
exports.setSettingsApi = setSettingsApi;
exports.makeEmptySingleEditorApi = makeEmptySingleEditorApi;
/* api Not a pure module */
